import React from 'react';

import Modal from 'ui-library/modals/Modal';

export interface ScientificModelInputFormProps {
  model: string;
}

export function ScientificModelInputForm({model}: ScientificModelInputFormProps): JSX.Element {
  return <div>Input form for {model}</div>;
}

export interface ScientificModelInputFormModalProps {
  model: string;
  onRequestClose: () => void;
}

export function ScientificModelInputFormModal({
  model,
  onRequestClose,
}: ScientificModelInputFormModalProps): JSX.Element {
  return (
    <Modal
      title={`Configure ${model}`}
      onRequestClose={onRequestClose}
      closeableOnBackgroundClick={true}
      large={true}
      fullHeight={true}
    >
      <ScientificModelInputForm model={model} />
    </Modal>
  );
}
